import { IconButton, Tooltip } from '@crazyegginc/hatch';

import { useAuthContext, useSite } from '/src/hooks';
import { SOURCE_TYPE } from '/src/components/source-selector/source-selector';
import { AppLink } from '/src/features/_global/components/AppLink';

import { ReactComponent as HeatmapsIcon } from '@crazyegginc/hatch/dist/images/icon-heat-filled.svg';

export function InstantHeatmaps({ selectedSource, path, domain = null }) {
  const { isSharing } = useAuthContext();
  const { sites } = useSite({ dontSelectSite: true });

  // skip rendering if we're in a shared view, as heatmaps
  // require the user to be logged in.
  if (isSharing) return null;

  if (!path || path.includes('*')) return null;

  if (selectedSource?.type === SOURCE_TYPE.GA_PROPERTY) {
    const gaSite = findSiteForGADomain(domain, sites);
    if (!gaSite || !gaSite?.installed) {
      return (
        <Tooltip
          tooltipContent={
            <div className="px-2 py-1 font-semibold text-[14px]">
              Get Instant Heatmaps by installing Crazy Egg.
              <br /> Click to Install.
            </div>
          }
        >
          <IconButton
            icon={<HeatmapsIcon className="h-4 w-4 fill-current" />}
            component={AppLink}
            className="text-cadet-blue-500 !p-0"
            to="/install"
            label="Install Crazy Egg"
          />
        </Tooltip>
      );
    }
  }

  return (
    <Tooltip tooltipContent={<div className="px-2 py-1 font-semibold text-[14px]">View Instant Heatmap</div>}>
      <IconButton
        icon={<HeatmapsIcon className="h-4 w-4 fill-current" />}
        className="text-california-500 !p-0"
        onClick={() => {
          if (window.HudLauncher?.open) {
            const hostname = domain || selectedSource?.name;
            const normalizedPath = path.startsWith('/') ? path : `/${path}`;
            if (hostname) {
              window.HudLauncher.open(`https://${hostname}${normalizedPath}`, { powerup: true });
            }
          }
        }}
        label="View Instant Heatmap"
      />
    </Tooltip>
  );
}

function findSiteForGADomain(gaDomain, sites) {
  if (!sites || sites.length === 0 || !gaDomain) return null;

  const domain = gaDomain.toLowerCase();

  return sites.find((site) => domain === site.name || domain.endsWith('.' + site.name));
}
